import pubsub from "sweet-pubsub";
import { flattenErrors } from "./flattenErrors";

const show = (toast: any) => pubsub.emit("toast", toast);

export const success = (title: any, message?: any) => {
    show({ title, message });
};

const getErrorMessage = (err: unknown): string | undefined => {
    if (typeof err === "string") {
        return err;
    }

    if (err instanceof Error) {
        return err.message;
    }

    if (err && typeof err === "object") {
        return flattenErrors(err as Record<string, any>);
    }

    return undefined;
};

export const error = (errorTitle: string, err?: unknown) => {
    const messages = getErrorMessage(err);

    show({
        type: "error",
        title: errorTitle,
        message: messages,
        duration: 3,
    });
};

export const warning = (warningTitle: string, warningMessage?: any) => {
    show({
        type: "warning",
        title: warningTitle,
        message: warningMessage,
        duration: 3,
    });
};
